import { Injectable } from '@angular/core';
import {ApiService} from "../../services/api.service";

@Injectable()
export class CommentaryService {

  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  getLastUpdated() {
    return this.apiService.getEiaUrl('commentary/updated', {});
  }

  getCommentary() {
    return this.apiService.getEiaUrl('commentary', {});
  }

  getCommentaryById(id) {
    return this.apiService.getEiaUrl('commentary/' + id, {});
  }
  // logic here to get the commentary from wherever it is and return it as an array of html
  getCommentaryItems(commentaryId){ //commentary could be pulled based on a id
    var data: any = [];
    var testItem1 = {
      id : 1,
        header:`EIA projects lower natural gas stocks for the start of the 2018-2019 winter heating season compared with recent years despite the expected typical summer injections`,
        date: `May 31, 2018`,
        body: `
        <img src="assets/commentary/20180531/fig1.png" width="600px"
           alt="Seasonal changes in natural gas inventories (2010-2018)">
      <p class="source">Sources:  U.S. Energy Information Administration: <i>Weekly Natural Gas Storage Report</i>; <i>Short-Term Energy Outlook</i>, May 2018; <i>Natural Gas Monthly</i>, May 2018.</p>

      <p>EIA projects that Lower 48 underground natural gas storage inventories may be only 3,491 billion cubic feet (Bcf) at the start of the 2018–19 winter heating season—the lowest level for the start of winter since 2006. Current Lower 48 underground natural gas storage inventories are 1,725 Bcf, or about 23% below the five-year (2013–17) average and about 31% below last summer’s natural gas storage levels at this time.  Natural gas injections between now and October 31 will need to be almost 1,800 Bcf to bring pre-winter inventories above 3,500 Bcf. </p>

      <p>Although April 1 (the start of injection season) inventories were low this year (1,389 Bcf), they were not as low as in 2014 when much colder-than-normal temperatures associated with the Polar Vortex resulted in end-of-winter inventories of less than 900 Bcf. EIA estimates that weekly net injections will need to average about 80 Bcf between now and October 31 to reach EIA’s current start-of-winter inventory estimate or about 90 Bcf to reach the most recent five-year average.</p>

      <p>
        Several factors could influence the pace of natural gas injections this summer including:
      </p>
      <ul>
        <li>the relatively low inventory starting point going into May</li>
        <li>whether projections of warmer-than-normal weather pan out in high electricity demand areas</li>
        <li>the extent of natural gas pipeline maintenance</li>
        <li>natural gas production trends</li>
        <li>the completion of natural gas pipeline capacity additions</li>
        <li>the price of natural gas</li>
        <li>the availability of nuclear generating capacity</li>
      </ul>

      <p>Check EIA’s Natural Gas Storage Dashboard every week for updated information on this summer’s injection profile.</p>`
    };


    var testItem2 = {
        id : 2,
        header:`EIA projects lower natural gas stocks for the start of the 2018-2019 winter heating season compared with recent years despite the expected typical summer injections`,
        date: `June 1, 2018`,
        body: `
        <img src="assets/commentary/20180531/fig1.png" width="600px"
           alt="Seasonal changes in natural gas inventories (2010-2018)">
      <p class="source">Sources:  U.S. Energy Information Administration: <i>Weekly Natural Gas Storage Report</i>; <i>Short-Term Energy Outlook</i>, May 2018; <i>Natural Gas Monthly</i>, May 2018.</p>

      <p>EIA projects that Lower 48 underground natural gas storage inventories may be only 3,491 billion cubic feet (Bcf) at the start of the 2018–19 winter heating season—the lowest level for the start of winter since 2006. Current Lower 48 underground natural gas storage inventories are 1,725 Bcf, or about 23% below the five-year (2013–17) average and about 31% below last summer’s natural gas storage levels at this time.  Natural gas injections between now and October 31 will need to be almost 1,800 Bcf to bring pre-winter inventories above 3,500 Bcf. </p>

      <p>Although April 1 (the start of injection season) inventories were low this year (1,389 Bcf), they were not as low as in 2014 when much colder-than-normal temperatures associated with the Polar Vortex resulted in end-of-winter inventories of less than 900 Bcf. EIA estimates that weekly net injections will need to average about 80 Bcf between now and October 31 to reach EIA’s current start-of-winter inventory estimate or about 90 Bcf to reach the most recent five-year average.</p>

      <p>
        Several factors could influence the pace of natural gas injections this summer including:
      </p>
      <ul>
        <li>the relatively low inventory starting point going into May</li>
        <li>whether projections of warmer-than-normal weather pan out in high electricity demand areas</li>
        <li>the extent of natural gas pipeline maintenance</li>
        <li>natural gas production trends</li>
        <li>the completion of natural gas pipeline capacity additions</li>
        <li>the price of natural gas</li>
        <li>the availability of nuclear generating capacity</li>
      </ul>

      <p>Check EIA’s Natural Gas Storage Dashboard every week for updated information on this summer’s injection profile.</p>`
    };

    data.push(testItem1);
    data.push(testItem2);


    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/commentary/services/commentary.service.ts